/** Catálogo dos módulos do app — integração com a API. */

import apiClient from './apiClient';
import type { DadosDoModuloDoApp, ModuloDoApp } from '../types/benefitModule';

export * from '../types/benefitModule';

export const benefitModuleService = {
  /** `apenasAtivos` é o que o formulário da proposta pede; o cadastro lista tudo. */
  async listar(apenasAtivos = false): Promise<ModuloDoApp[]> {
    const { data } = await apiClient.get<ModuloDoApp[]>(
      `/modulos-do-app${apenasAtivos ? '?apenasAtivos=true' : ''}`
    );
    if (!data) throw new Error('Resposta vazia do servidor ao listar os módulos');
    return data;
  },

  async criar(dados: DadosDoModuloDoApp): Promise<ModuloDoApp> {
    const { data } = await apiClient.post<ModuloDoApp>('/modulos-do-app', dados);
    if (!data) throw new Error('Resposta vazia do servidor ao cadastrar o módulo');
    return data;
  },

  async atualizar(id: number, dados: DadosDoModuloDoApp): Promise<ModuloDoApp> {
    const { data } = await apiClient.put<ModuloDoApp>(`/modulos-do-app/${String(id)}`, dados);
    if (!data) throw new Error('Resposta vazia do servidor ao salvar o módulo');
    return data;
  },

  async remover(id: number): Promise<void> {
    await apiClient.delete(`/modulos-do-app/${String(id)}`);
  },
};

export default benefitModuleService;
